import { render } from "@/components/pages/individualWorkSupport/requirement151/Requirement151.html?vue&type=template&id=22a39e76&external"
import script from "@/components/pages/individualWorkSupport/requirement151/Requirement151.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement151/Requirement151.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__